import { faTriangleExclamation, faCheck } from "@fortawesome/free-solid-svg-icons";
import EditButton from "../EditButton/EditButton";
import { Button } from "components/Button/Button";
import "./ChangeList.scss";

export const PUBLISH_STATUS = {
	UNPUBLISHED: 0,
	PUBLISHED: 1,
};

const PUBLISH_STATUS_META = {
	[PUBLISH_STATUS.UNPUBLISHED]: {
		label: "Unpublished",
		icon: faTriangleExclamation,
		color: "#F68B1F",
		className: "is-unpublished",
	},
	[PUBLISH_STATUS.PUBLISHED]: {
		label: "Published",
		icon: faCheck,
		color: "#1ea324",
		className: "is-published",
	},
};

const getPublishStatusMeta = (status) =>
	PUBLISH_STATUS_META[status] ?? { label: `Unknown (${status})`, icon: null, color: "#999", className: "is-unknown" };

const ChangeList = ({ status, changes = [], onUndoField, handleOpenDiscardModal }) => {
	const { className } = getPublishStatusMeta(status);

	return (
		<div className={`change-list ${className}`}>
			<h1>Current Changes{" "}</h1>

			{Array.isArray(changes) && changes.length > 0 ? (
				<>
					{changes.map((item, index) => {
						const isObject = item && typeof item === "object";

						const isHeader = isObject && "level" in item && "name" in item;
						const isAction = isObject && "label" in item; 

						if (isHeader) {
							const { level, action, name } = item;
							return (
								<p key={index} className="change-list-header">
									+ {level} {action} -{" "}
									<span className="change-list-header-name">{name}</span>
								</p>
							);
						}

						if (isAction) {
							const { label, field } = item;
							return (
								<div key={index} className="change-list-item">
									<p className="change-list-item-text">{label}</p>
									{field && typeof onUndoField === "function" && (
										<span className="change-list-item-undo" style={{ marginLeft: 8 }}>
											<EditButton undo onClick={() => onUndoField(field)} />
										</span>
									)}
								</div>
							);
						}

						// Fallback for legacy string entries
						return (
							<div key={index} className="change-list__item">
								<span className="change-list__text">{item}</span>
							</div>
						);
					})}
					<div className="discard-button">
						<Button text="Discard Current Changes" onClick={handleOpenDiscardModal} />
					</div>
				</>
			) : (
				<p>No unpublished changes detected.</p>
			)}
		</div>
	);
};

export default ChangeList;
